package org.zest.insan_360_website.model

import kotlinx.serialization.Serializable

@Serializable
sealed interface ApiResponseWrapper

@Serializable
data class GenericResponse(
    val success: Boolean,
    val errorCode: ApiErrorCode? = null,
    val successCode: ApiSuccessCode? = null,
    val debugMessage: String? = null
) : ApiResponseWrapper

@Serializable
data class ApiResponse<T>(
    val success: Boolean,
    val data: T? = null,
    val successCode: ApiSuccessCode? = null,
    val debugMessage: String? = null
) : ApiResponseWrapper

@Serializable
data class GenericPaymentResponse(
    val success: Boolean,
    val redirectUrl: String
) : ApiResponseWrapper